import AnimatedDropdown from 'components/AnimatedDropdown'
import Column from 'components/Column'
import { StyledDropDown } from 'components/Icons/StyledIcon'
import React, { PropsWithChildren, ReactElement } from 'react'
import styled from 'styled-components/macro'

import Row, { RowBetween } from '../Row'

const ButtonContainer = styled(Row)`
  cursor: pointer;
  justify-content: flex-end;
  width: unset;
`

const ExpandIcon = styled.div<{ $isOpen: boolean }>`
  display: inline-flex;
  color: ${({ theme }) => theme.textSecondary};
  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform ${({ theme }) => theme.transition.duration.medium};
`

const Content = styled(Column)`
  padding-top: ${({ theme }) => theme.grids.md};
`

export default function Expand({
  header,
  button,
  children,
  testId,
  isOpen,
  onToggle,
}: PropsWithChildren<{
  header: ReactElement
  button: ReactElement
  testId?: string
  isOpen: boolean
  onToggle: () => void
}>) {
  return (
    <Column width="100%">
      <RowBetween>
        {header}
        <ButtonContainer data-testid={testId} onClick={onToggle} aria-expanded={isOpen}>
          {button}
          <ExpandIcon $isOpen={isOpen}>
            <StyledDropDown />
          </ExpandIcon>
        </ButtonContainer>
      </RowBetween>
      <AnimatedDropdown open={isOpen}>
        <Content gap="md">{children}</Content>
      </AnimatedDropdown>
    </Column>
  )
}

export function Expand2({
  header,
  button,
  children,
  testId,
  isOpen,
  onToggle,
}: PropsWithChildren<{
  header: ReactElement
  button: ReactElement
  testId?: string
  isOpen: boolean
  onToggle: () => void
}>) {
  return (
    <Column width="100%">
    <RowBetween>
      {header}
      <ButtonContainer data-testid={testId} onClick={onToggle} aria-expanded={isOpen}>
        {button}
      </ButtonContainer>
    </RowBetween>
    <AnimatedDropdown open={isOpen}>
      <Content gap="md">{children}</Content>
    </AnimatedDropdown>
  </Column>
  )
}
